import { render, staticRenderFns } from "./messengers.vue?vue&type=template&id=4316f5a4&scoped=true"
import script from "./messengers.vue?vue&type=script&lang=js"
export * from "./messengers.vue?vue&type=script&lang=js"
import style0 from "./messengers.vue?vue&type=style&index=0&id=4316f5a4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4316f5a4",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/messengers.vue
// module id = ngmt
// module chunks = 0